import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('fr');
  const toggleLang = () => setLang(l => l === 'fr' ? 'en' : 'fr');
  return (
    <LanguageContext.Provider value={{ lang, toggleLang, isFr: lang === 'fr' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
